import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { HXMobileButton } from "./HXButton";
export const LongPressButton = (props) => {
    const [longPressMode, setLongPressMode] = React.useState(false);
    const touchTimer = React.useRef(null);
    const [touchChangedMode, setTouchChangedMode] = React.useState(false);
    return (_jsx(HXMobileButton, { onTouchStart: onTouchStart, onTouchEnd: onTouchEnd, onMouseDown: onTouchStart, onMouseUp: onTouchEnd, ...props, onClick: onClick, children: longPressMode ? props.longPressLabel : props.label }));
    async function onClick(event) {
        var _a;
        event.preventDefault();
        if (touchChangedMode)
            return;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, longPressMode, event);
    }
    async function onTouchStart() {
        touchTimer.current = window.setTimeout(() => {
            setLongPressMode(!longPressMode);
            setTouchChangedMode(true);
        }, 5000);
    }
    function onTouchEnd() {
        if (touchTimer.current !== null) {
            window.clearTimeout(touchTimer.current);
            touchTimer.current = null;
        }
        if (touchChangedMode) {
            window.setTimeout(() => {
                setTouchChangedMode(false);
            }, 50);
        }
    }
};
